<template>
  <div class="verification-details-company-info">
    <template v-if="verification.isNotEmptyKyb && companyInfo.registrationNumber">
      <a-collapse
        :active-key="activeKeys"
        expand-icon-position="right"
      >
        <a-collapse-panel
          :force-render="true"
          key="verification-details-company-info.key-info"
          :header="'verification-details-company.title' | globalize">
          <details-reader
            :with-accordion="true"
            :details="companyInfo" />
        </a-collapse-panel>

        <a-collapse-panel
          :force-render="true"
          key="verification-details-company-info.docs-info"
          :header="'verification-details-company.title-docs' | globalize">
          <veriication-details-company-docs :company-docs="companyDocsAsFlatList" />
        </a-collapse-panel>

        <a-collapse-panel
          :force-render="true"
          key="verification-details-company-info.key-beneficiaries"
          :header="'verification-details-company.title-beneficiaries' | globalize">
          <company-beneficiaries
            :data-source="beneficiaries"
          />
        </a-collapse-panel>
      </a-collapse>
    </template>
    <template v-else>
      No data for company on provider
    </template>
  </div>
</template>

<script>

import { VerificationRecord } from '@/js/records/entities/verification.record'
import DetailsReader from '@/vue/common/DetailsReader/DetailsReader'
import CompanyBeneficiaries from '@/vue/common/company-beneficiaries/beneficiaries-list'
import VerificationDetailsCompanyDocs from './company-info/VeriicationDetailsCompanyDocs'
import ACollapse from 'ant-design-vue/lib/collapse/Collapse'
import ACollapsePanel from 'ant-design-vue/lib/collapse/CollapsePanel'
import { imageUrlToSumsubDocs } from '@/js/helpers/urls'

export default {
  name: 'verification-details-company-info',
  components: {
    DetailsReader,
    /* eslint-disable-next-line */
    'veriication-details-company-docs': VerificationDetailsCompanyDocs,
    'a-collapse': ACollapse,
    'a-collapse-panel': ACollapsePanel,
    CompanyBeneficiaries,
  },
  props: {
    verification: {
      type: VerificationRecord,
      required: true,
    },
    companyInfo: {
      type: Object,
      required: true,
    },
    companyDocs: {
      type: Array,
      required: true,
    },
    beneficiaries: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {
      activeKeys: [
        'verification-details-company-info.key-info',
        'verification-details-company-info.docs-info',
        'verification-details-company-info.key-beneficiaries',
      ],
    }
  },
  computed: {
    companyDocsAsFlatList () {
      const { inspectionId } = this.companyInfo

      const flatList = []

      this.companyDocs.forEach(doc => {
        doc.images && doc.images.forEach(image => {
          image.url = imageUrlToSumsubDocs(inspectionId, image.imageId)
          const row = {
            ...image,
            group: doc.id,
          }

          flatList.push(row)
        })
      })

      return flatList
    },
  },
}
</script>

<style lang="scss">
  @import '~@scss/variables';
  @import '~ant-design-vue/lib/collapse/style/index.css';

  .verification-details-company-sumsub-review-status-GREEN {
    color: $col-sumsub-review-answer-green;
    font-weight: 600;
  }

  .verification-details-company-sumsub-review-status-RED {
    color: $col-sumsub-review-answer-red;
    font-weight: 600;
  }

</style>
